module.exports = __webpack_public_path__ + "media/images/icons/link-642c0ec1013ff8f0a46e7253a5279864.svg";